// extracted by mini-css-extract-plugin
export default {"searchBoxPrefix":"ManageCourses_searchBoxPrefix__AlAQP","icon":"ManageCourses_icon__ONK1W","option":"ManageCourses_option__xe8ei","active":"ManageCourses_active__h87hy"};